<template>
  <div>
    <select name="year" class="short" v-model.number="year" v-on:change="modify">
      <option v-for="(year ,index) in getYears()" :value="year" :key="index">
        {{ year }}
      </option>
    </select> 年
    <select name="month" class="very-short" v-model.number="month" v-on:change="modify">
      <option v-for="(month, index) in months" :value="month" :key="index">
        {{ month }}
      </option>
    </select> 月
    <select name="date" class="very-short" v-model.number="date" v-on:change="modify">
      <option v-for="(date ,index) in getDates(year, month)" :value="date" :key="index">
        {{ date }}</option>
    </select> 日
  </div>
</template>

<script>
export default {
  data ()  {
    return  {
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: 2000,
      month: 1 , 
      date: 1,
    }
  },
  props: {
    propDate: { 
      required: false
    }
  },
  mounted () {
    this.$emit('bindDate' , this.year , this.month - 1 , this.date)
  },
  methods: {
    getYears () {
      const goBackYears = 100
      const currentYear = this.$moment().year()
      const startYear = currentYear - goBackYears
      return [...Array(goBackYears + 1).keys()].map(x => x + startYear)
    },
    getDates (year , month) {
        const maxDate = this.getFinalDate(year, month)
        return [...Array(maxDate).keys()].map(x => x + 1)
    },
    modify () {
      if (!this.$moment([this.year, this.month - 1, this.date]).isValid() && this.isNotEmpty(this.date)) {
        this.date = this.getFinalDate(this.year, this.month)
      }
      if(this.isNotEmpty(this.year) && this.isNotEmpty(this.month) && this.isNotEmpty(this.date)) {
        this.$emit('bindDate' , this.year , this.month - 1 , this.date)
      }
    },
    getFinalDate (year, month) {
      return this.$moment([year, month - 1]).endOf('month').date()
    },
  },
  watch: {
    propDate() {
      if(this.isNotEmpty(this.propDate)){
        // 年
        if(this.isNotEmpty(this.propDate.getFullYear())) {
          this.year = this.propDate.getFullYear()
        }
        // 月
        if(this.isNotEmpty(this.propDate.getMonth())) {
          this.month = this.propDate.getMonth() + 1
        }
        // 日
        if(this.isNotEmpty(this.propDate.getDate())) {
          this.date = this.propDate.getDate()
        }
      }
    },
  }
}

</script>